/**
 * Accettazione — coreBOS `evAcceptance` (77x) on evo-gdpr.evolutivo.it.
 * Harvested from evo-mcp-limitless@origin/evo-policies by scripts/harvest/gen_descriptors.py.
 * Frameworks: gdpr,nis2,dlgs81. Type sources per field: docs/harvest-report.md.
 * Regenerate instead of hand-editing; hand edits belong in the generator's SPEC.
 */
export const acceptanceDescriptor = {
    slug: 'cmp_acceptance',
    kind: 'document',
    label: { singular: 'Accettazione', plural: 'Accettazioni' },
    table: 'compliance_acceptance',
    idStrategy: 'sha256',
    fields: [
        { name: 'acctitle', type: 'text', label: 'Titolo', required: true },
        { name: 'acceptance_status', type: 'text', label: 'Stato' },
        { name: 'acclastdate', type: 'date', label: 'Data' },
        { name: 'accmethod', type: 'text', label: 'Metodo' },
        { name: 'acclevelescal', type: 'text', label: 'Livello Escalation' },
        { name: 'email_opened', type: 'boolean', label: 'Email Aperta' },
        { name: 'contact_type', type: 'text', label: 'Tipo Contatto' },
        { name: 'evacceptance_no', type: 'text', label: 'Numero' },
        { name: 'description', type: 'text', label: 'Descrizione' },
    ],
    relations: [
        { name: 'acctopolicy', kind: 'belongsTo', target: 'cmp_policy' },
        { name: 'acceptancetocontent', kind: 'belongsTo', target: 'cmp_content' },
        { name: 'pacclinktocontact', kind: 'belongsTo', target: 'contact', toEntitySpine: true },
        { name: 'acctoemployee', kind: 'belongsTo', target: 'contact', toEntitySpine: true },
        { name: 'assigned_user', kind: 'belongsTo', target: 'user', toEntitySpine: true },
    ],
    behaviors: { ownership: true, audit: true, softDelete: true, tenantScoped: true },
    ui: { mode: 'generated', icon: 'CheckCircleOutlined', navGroup: 'Policy' },
};
